if (!customElements.get('cart-selling-points-slider')) {
  class CartSellingPointsSlider extends HTMLElement {
    constructor() {
      super();
      this.classes = {
        activeSlide: 'cart-selling-points-slider__slide--active',
      };

      this.slides = [...this.querySelectorAll('[data-cart-selling-points-slide]')];
      this.index = 0;
      this.timer = null;
    }

    connectedCallback() {
      if (this.slides.length <= 1) return;

      this.slides[0].classList.add(this.classes.activeSlide);

      const duration = this.getDuration();

      this.timer = setInterval(() => {
        this.goNext();
      }, duration);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    goNext() {
      this.slides[this.index].classList.remove(this.classes.activeSlide);
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add(this.classes.activeSlide);
    }

    getDuration() {
      const value = getComputedStyle(this).getPropertyValue('--animation-duration').trim();

      return this.cssTimeToMs(value) || 3000;
    }

    cssTimeToMs(value) {
      if (value.endsWith('ms')) return parseFloat(value);
      if (value.endsWith('s')) return parseFloat(value) * 1000;
      return Number(value) || 0;
    }
  }

  customElements.define('cart-selling-points-slider', CartSellingPointsSlider);
}
